<template>
  <div>
    <div id="content" class="content animated slideInRight delay-1s">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <div class="card-title">
                Cadastrar Tipo de Veículo
                <span class="required_fields"
                  ><span class="required">*</span> Campos obrigatórios</span
                >
              </div>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-md-12">
                  <form id="form">
                    <div class="row">
                      <div class="col-md-12">
                        <div class="alert alert-primary" role="alert">
                          <strong>Atenção!</strong> Agora você pode informar uma
                          faixa de kilometragem para cada tipo de veículo, desta
                          forma, assim que um usuário for realizar uma reserva,
                          ele informará qual distância pretende rodar, e o
                          sistema irá sugerir o tipo de veículo ideal para
                          determinada distância.
                        </div>
                      </div>
                      <div class="col-md-12">
                        <div class="alert alert-dark" role="alert">
                          <strong>Observação!</strong> Informar um raio de
                          kilometragem não é obrigatório, se os dois campos
                          estiverem em branco, o tipo de veículo será sugerido
                          em todas as distâncias informadas. Se apenas o
                          <strong>KM Final</strong> estiver em branco, será
                          considerado como "infinito".
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group">
                          <label for="description"
                            ><span class="required">*</span> Descrição:</label
                          >
                          <input
                            type="text"
                            class="form-control"
                            v-model="vehicleType.description"
                          />
                        </div>
                      </div>
                      <div class="col-md-3">
                        <label for="description"
                          ><span class="required"></span> KM Inicial:</label
                        >
                        <input
                          type="text"
                          class="form-control"
                          v-model="vehicleType.km_start"
                        />
                      </div>
                      <div class="col-md-3">
                        <label for="description"
                          ><span class="required"></span> KM Final:</label
                        >
                        <input
                          type="text"
                          class="form-control"
                          v-model="vehicleType.km_end"
                        />
                      </div>
                    </div>
                    <hr />
                    <div class="block text-right">
                      <a class="btn btn-add" @click="save">
                        Salvar <i class="fa fa-save"></i>
                      </a>
                      <router-link to="/vehicleTypes" class="btn btn-back">
                        <i class="fa fa-arrow-left"></i> Voltar
                      </router-link>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      vehicleType: {
        description: "",
        model_id: "",
      },
    };
  },
  methods: {
    save: function () {
      const self = this;
      let api = self.$store.state.api + "vehicleTypes";

      if (self.vehicleType.id) {
        api += "/" + self.vehicleType.id;
        self.vehicleType._method = "PUT";
      }

      self.$http
        .post(api, self.vehicleType)
        .then((response) => {
          self.$message(
            "Sucesso",
            `Informações guardadas com sucesso`,
            "success"
          );
          this.$router.push("/vehicleTypes");
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getVehicleType: function (id) {
      const self = this;
      const api = self.$store.state.api + "vehicleTypes/" + id;

      self.$http
        .get(api)
        .then((response) => {
          self.vehicleType = response.data.data[0];
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
  },
  mounted: function () {
    const self = this;
    let id = self.$route.params.id;
    if (id) {
      self.getVehicleType(id);
    }
  },
};
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/VehicleTypes/Add.vue